import { useQuery } from "@apollo/client";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import React, { ReactElement } from "react";

import { Template } from "../../generated/gql/graphql";
import { GetTemplatesGQL } from "../../hooks/use-templates";

type Props = {
  templateId: string | null;
  title: string;
  onTemplateIdChange: (templateId: string | null) => void;
};

export default function TemplateSelector(props: Props): ReactElement {
  const { templateId, title, onTemplateIdChange } = props;
  const { data } = useQuery(GetTemplatesGQL, {
    fetchPolicy: "network-only",
  });
  const templates: Pick<Template, "id" | "name">[] =
    data?.templates?.items ?? [];

  const handleChange = (event: SelectChangeEvent): void => {
    const value = event.target.value;
    onTemplateIdChange(value === "" ? null : value);
  };

  return (
    <Box>
      <FormControl className="min-w-[220px]" size="small">
        <InputLabel>{title}</InputLabel>
        <Select
          className="rounded-[15px] border-0 text-left text-[14px]"
          value={templateId ?? ""}
          label={title}
          onChange={handleChange}
        >
          <MenuItem value="">
            <em>No template</em>
          </MenuItem>
          {templates.map((t) => (
            <MenuItem key={t.id} value={t.id}>
              {t.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
